/* T.LUXY V20 — Add-to-cart effect.
   Watches successful POSTs to /cart/add (it never changes the request or the
   response). On success it plays a short "fly to bag" animation, then lets
   the theme continue as usual (in "page" cart mode the theme redirects to
   /cart). On the cart page it highlights the item just added.
   Any error in this file is swallowed: the purchase flow never depends on it.
*/
(() => {
  'use strict';
  const KEY = 'tluxyJustAdded';
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isIt = (document.documentElement.lang || '').toLowerCase().startsWith('it');
  let lastButton = null;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('button[type="submit"], [type="submit"][name="add"], [data-add-to-cart]');
    if (btn) lastButton = btn;
  }, true);

  const visible = (el) => {
    if (!el) return false;
    const r = el.getBoundingClientRect();
    return r.width > 40 && r.height > 40 && r.bottom > 0 && r.top < window.innerHeight && getComputedStyle(el).visibility !== 'hidden';
  };

  function sourceImage() {
    const scope = (lastButton && lastButton.closest('[data-product-grid-item], .product-item, [data-quickbuy-form], .shopify-section--product, [data-section-type], .shopify-section')) || document;
    const imgs = [...scope.querySelectorAll('[data-product-single-media-wrapper] img, .product-item img, img')];
    const shown = imgs.find(visible);
    if (shown) return { src: shown.currentSrc || shown.src, rect: shown.getBoundingClientRect() };
    // Image scrolled out of view (common on mobile): start from the button.
    const any = imgs.find((i) => (i.currentSrc || i.src) && i.naturalWidth > 40);
    if (!any || !lastButton) return null;
    const b = lastButton.getBoundingClientRect();
    const side = Math.min(120, window.innerWidth * 0.3);
    return { src: any.currentSrc || any.src, rect: { left: b.left + b.width / 2 - side / 2, top: b.top - side - 8, width: side, height: side } };
  }

  function cartTarget() {
    const links = [...document.querySelectorAll('a[href$="/cart"], a[href*="/cart?"], [data-cart-toggle]')];
    return links.find((a) => { const r = a.getBoundingClientRect(); return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < 220 && getComputedStyle(a).visibility !== 'hidden'; }) || null;
  }

  function variantFrom(init) {
    try {
      const body = init && init.body;
      if (!body) return null;
      if (body instanceof FormData) return body.get('id') || body.get('items[0][id]');
      if (body instanceof URLSearchParams) return body.get('id');
      if (typeof body === 'string') {
        try { const j = JSON.parse(body); return (j.items && j.items[0] && j.items[0].id) || j.id || null; }
        catch (_) { return new URLSearchParams(body).get('id'); }
      }
    } catch (_) { /* ignore */ }
    return null;
  }

  function bumpBadge() {
    document.querySelectorAll('[data-tluxy-cart-count]').forEach((b) => {
      const n = parseInt(b.textContent, 10) || 0;
      b.textContent = String(n + 1);
      b.hidden = false; b.classList.remove('is-hidden');
      b.classList.remove('tluxy-badge-pop'); void b.offsetWidth; b.classList.add('tluxy-badge-pop');
    });
  }

  function buttonDone() {
    const btn = lastButton;
    if (!btn) return;
    const label = btn.querySelector('[data-add-to-cart-text]') || btn;
    if (!label.dataset.tluxyOrig) label.dataset.tluxyOrig = label.innerHTML;
    label.innerHTML = '<span class="tluxy-added-check" aria-hidden="true"></span>' + (isIt ? 'Aggiunto' : 'Added');
    btn.classList.add('tluxy-added');
    setTimeout(() => { label.innerHTML = label.dataset.tluxyOrig; btn.classList.remove('tluxy-added'); }, 2600);
  }

  // Returns how long the theme should wait before continuing (ms).
  function play() {
    buttonDone();
    const img = sourceImage();
    const target = cartTarget();
    if (reduce || !img || !target || !document.body.animate) { bumpBadge(); return reduce ? 250 : 450; }

    const s = img.rect;
    const t = target.getBoundingClientRect();
    const k = Math.min(1, 340 / Math.max(s.width, s.height));
    const w = s.width * k, h = s.height * k;
    const ghost = document.createElement('div');
    ghost.className = 'tluxy-fly';
    ghost.style.cssText = `left:${s.left + (s.width - w) / 2}px;top:${s.top + (s.height - h) / 2}px;width:${w}px;height:${h}px;background-image:url("${img.src}")`;
    document.body.appendChild(ghost);

    const dx = t.left + t.width / 2 - (s.left + s.width / 2);
    const dy = t.top + t.height / 2 - (s.top + s.height / 2);
    const dur = 650;
    ghost.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: `translate(${dx * 0.45}px, ${dy * 0.45 - 60}px) scale(.55)`, opacity: 1, offset: 0.45 },
      { transform: `translate(${dx}px, ${dy}px) scale(.08)`, opacity: .15 }
    ], { duration: dur, easing: 'cubic-bezier(.55,0,.25,1)', fill: 'forwards' });

    setTimeout(() => {
      ghost.remove();
      target.classList.remove('tluxy-cart-bump'); void target.offsetWidth; target.classList.add('tluxy-cart-bump');
      bumpBadge();
    }, dur - 40);
    return dur + 250;
  }

  // Wrap fetch: same request, same response; on a successful add we only
  // wait for the animation before handing the response back to the theme.
  if (window.fetch && !window.fetch.__tluxyFx) {
    const original = window.fetch;
    const wrapped = function (input, init) {
      const p = original.apply(this, arguments);
      let isAdd = false;
      try {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        isAdd = method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url);
      } catch (_) { isAdd = false; }
      if (!isAdd) return p;
      const variant = variantFrom(init);
      return p.then((res) => {
        if (!res || !res.ok) return res;
        let wait = 0;
        try {
          sessionStorage.setItem(KEY, JSON.stringify({ v: variant ? String(variant) : '', t: Date.now() }));
        } catch (_) { /* storage blocked */ }
        try { wait = play(); } catch (_) { wait = 0; }
        return wait ? new Promise((r) => setTimeout(() => r(res), wait)) : res;
      });
    };
    wrapped.__tluxyFx = true;
    window.fetch = wrapped;
  }

  // Cart page: highlight the item just added.
  function onCart() {
    if (!/\/cart\/?$/.test(location.pathname)) return;
    let data = null;
    try { data = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (_) { return; }
    if (!data || Date.now() - data.t > 60000) return;
    const item = (data.v && document.querySelector(`[data-item^="${CSS.escape(data.v)}:"]`)) || document.querySelector('[data-cart-item]');
    if (!item) return;
    item.classList.add('tluxy-just-added');
    const title = item.getAttribute('data-item-title') || '';
    const toast = document.createElement('div');
    toast.className = 'tluxy-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML = `<span class="tluxy-toast__check" aria-hidden="true"></span><span><strong>${isIt ? 'Aggiunto al carrello' : 'Added to bag'}</strong>${title ? `<br><small></small>` : ''}</span>`;
    if (title) toast.querySelector('small').textContent = title;
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('is-in'));
    setTimeout(() => { toast.classList.remove('is-in'); setTimeout(() => toast.remove(), 500); }, 3200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onCart, { once: true });
  else onCart();
})();
